/* eslint-disable import/no-extraneous-dependencies */
import { Route, Routes } from 'react-router';

import LanguagesPage from '../../features/checking/LanguagesPage';
import HotelsPage from '../../features/checking/HotelsPage';
import CheckingPage from '../../features/checking/CheckingPage';
import ImportantRememberPage from '../../features/checking/ImportantRememberPage';
import FinishedPage from '../../features/checking/FinishedPage';
import BookingPage from '../../features/booking/BookingPage';
import BookingMotivePage from '../../features/booking/BookingMotivePage';
import GuestDocumentFrontPage from '../../features/guests/GuestDocumentFrontPage';
import GuestDocumentReversePage from '../../features/guests/GuestDocumentReversePage';
import GuestDocumentFrontCapturePage from '../../features/guests/GuestDocumentFrontCapturePage';
import GuestDocumentReverseCapturePage from '../../features/guests/GuestDocumentReverseCapturePage';
import GuestDocumentPreviewPage from '../../features/guests/GuestDocumentPreviewPage';
import GuestDocumentationReviewPage from '../../features/guests/GuestDocumentationReviewPage';
import GuestDocumentationEditPage from '../../features/guests/GuestDocumentationEditPage';
import GuestResidencePage from '../../features/guests/GuestResidencePage';
import GuestContractSignPage from '../../features/guests/GuestContractSignPage';
import MainLayout from '../../layouts/MainLayout';
import ButtonBack from '../../ui/ButtonBack';
import useBlockerNavigation from '../../hooks/useBlockerNavigation';
import PrivateRouter from './PrivateRouter';
import useNavigationGuard from '../../hooks/useNavigationGuard';
import useClearSession from '../../hooks/useClearSession';
import useNavigationTracker from '../../hooks/useNavigationTracker';

function MainRouter() {
  useNavigationTracker();
  // useBlockerNavigation();
  // useNavigationGuard();
  useClearSession();

  return (
    <Routes>
      <Route
        path="/"
        element={(
          <MainLayout>
            <LanguagesPage />
          </MainLayout>
        )}
      />
      <Route
        path="/Hotels"
        element={(
          <MainLayout>
            <ButtonBack pathName="/" />
            <HotelsPage />
          </MainLayout>
        )}
      />
      <Route
        path="/Checking"
        element={(
          <MainLayout>
            <ButtonBack pathName="/Hotels" styles={{ top: '220px' }} />
            <CheckingPage />
          </MainLayout>
        )}
      />
      <Route element={<PrivateRouter />}>
        <Route
          path="/Booking"
          element={(
            <MainLayout>
              <ButtonBack pathName="/" />
              <BookingPage />
            </MainLayout>
          )}
        />
        <Route
          path="/DocumentFront"
          element={(
            <MainLayout>
              <ButtonBack pathName="/Booking" />
              <GuestDocumentFrontPage />
            </MainLayout>
          )}
        />

        <Route
          path="/DocumentReverse"
          element={(
            <MainLayout>
              <ButtonBack pathName="/DocumentFront" />
              <GuestDocumentReversePage />
            </MainLayout>
          )}
        />
        <Route
          path="/DocumentFrontCapture"
          element={(
            <MainLayout>
              <ButtonBack pathName="/DocumentFront" classNames={{ icon: 'text-white', span: 'text-white' }} />
              <GuestDocumentFrontCapturePage />
            </MainLayout>
          )}
        />
        <Route
          path="/DocumentReverseCapture"
          element={(
            <MainLayout>
              <ButtonBack pathName="/DocumentPreview" classNames={{ icon: 'text-white', span: 'text-white' }} />
              <GuestDocumentReverseCapturePage />
            </MainLayout>
          )}
        />
        <Route
          path="/DocumentPreview"
          element={(
            <MainLayout>
              <ButtonBack pathName="/PrefixPreview" />
              <GuestDocumentPreviewPage />
            </MainLayout>
          )}
        />
        <Route
          path="/DocumentationReview"
          element={(
            <MainLayout>
              <ButtonBack pathName="/DocumentFront" />
              <GuestDocumentationReviewPage />
            </MainLayout>
          )}
        />
        <Route
          path="/DocumentationEdit"
          element={(
            <MainLayout>
              <ButtonBack pathName="/Booking" />
              <GuestDocumentationEditPage />
            </MainLayout>
          )}
        />
        <Route
          path="/Residence"
          element={(
            <MainLayout>
              <ButtonBack pathName="/DocumentationReview" />
              <GuestResidencePage />
            </MainLayout>
          )}
        />
        <Route
          path="/ContractSignature"
          element={(
            <MainLayout>
              <ButtonBack pathName="/Residence" />
              <GuestContractSignPage />
            </MainLayout>
          )}
        />
        <Route
          path="/BookingMotive"
          element={(
            <MainLayout>
              <ButtonBack pathName="/Booking" />
              <BookingMotivePage />
            </MainLayout>
          )}
        />
        <Route
          path="/ImportantRemember"
          element={(
            <MainLayout>
              <ImportantRememberPage />
            </MainLayout>
          )}
        />
        <Route
          path="/Finished"
          element={(
            <MainLayout>
              <FinishedPage />
            </MainLayout>
          )}
        />
      </Route>
    </Routes>
  );
}

export default MainRouter;
